import { ForceScrollContainer, ForceScrollWrapper } from "./DRE.styles"
import DREHeader from "./DREHeader"
import DREItem from "./DREItem"

/* eslint-disable */
const DRETable = ({ periods, rows }) => (
  <ForceScrollWrapper>
    <ForceScrollContainer>

      <DREHeader periods={periods} />

      {rows.map((item) => (
        <DREItem key={item.classification} item={item} />
      ))}

    </ForceScrollContainer>
  </ForceScrollWrapper>
)

export default DRETable